import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { parsePersonName } from "../../../../common/utils/parsePersonName";

const LABELS_APELLIDO = ["1er Apellido", "2do Apellido", "3er Apellido"];
const LABELS_NOMBRE = ["1er Nombre", "2do Nombre", "3er Nombre"];

export const NameParsePreview: React.FC<{ value: string }> = ({ value }) => {
  const parsed = React.useMemo(() => {
    if (!value || !value.includes(",")) return null;
    return parsePersonName(value);
  }, [value]);

  if (!parsed) {
    if (value && value.trim().length > 0 && !value.includes(",")) {
      return (
        <Box sx={{ mt: 0.5, mb: 1.5, ml: 1 }}>
          <Typography variant="caption" color="warning.main">
            Formato esperado: Apellidos, Nombres (separados por coma)
          </Typography>
        </Box>
      );
    }
    return null;
  }

  return (
    <Box sx={{ mt: 0.5, mb: 1.5, ml: 1, display: "flex", flexWrap: "wrap", gap: 0.5, alignItems: "center" }}>
      {parsed.apellidos.map((a, i) => (
        <Chip
          key={`a-${i}`}
          label={`${LABELS_APELLIDO[i]}: ${a}`}
          size="small"
          variant="outlined"
          color="primary"
          sx={{ fontSize: "0.75rem" }}
        />
      ))}
      {parsed.nombres.map((n, i) => (
        <Chip
          key={`n-${i}`}
          label={`${LABELS_NOMBRE[i]}: ${n}`}
          size="small"
          variant="outlined"
          color="secondary"
          sx={{ fontSize: "0.75rem" }}
        />
      ))}
    </Box>
  );
};
